/**************************************************
 * Nombre:       Home_Productos_Terna
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tarjeta_Producto from "../../Tarjetas/Tarjeta_Producto";
import {useEffect, useState} from "react";

const Home_Productos_Terna = ({arrItem}) => {
    const [productos, setProductos] = useState([]);

    const limpiarDuplicados = (arr) => {

        const mapa = new Map();

        arr.forEach(item => {
            // Usamos el número de celular como llave (key)
            mapa.set(item.id, item);
        });

        // Convertimos los valores del mapa de nuevo a un array
        return Array.from(mapa.values());

    }


    useEffect(() => {


        if (arrItem) {
            let arrProds = []

            for (let item of arrItem) {
                if (item.productos) {
                    arrProds.push(...item.productos);
                }

            }

            let arr = limpiarDuplicados(arrProds);

            setProductos(arr);
        }

    }, [arrItem])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={3}
        >

            {productos.map((it, index) => {
                return (
                    <Grid container size={{xs: 6, sm: 3, md: 2}}>
                        <Tarjeta_Producto item={it}/>
                    </Grid>
                )
            })}

        </Grid>
    )

}
export default Home_Productos_Terna